import React from 'react';

const User = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1303 5.08696C16.2173 2.78261 14.2607 1 11.9999 1C9.73901 1 7.73901 2.82609 7.86945 5.08696C7.91293 5.56522 8.34771 7.82609 8.34771 7.82609C8.69553 9.78261 9.99988 11.4348 11.9999 11.4348C13.9999 11.4348 15.3042 9.78261 15.6521 7.78261C15.6521 7.78261 16.0868 5.52174 16.1303 5.08696Z"
      stroke="#6A6A6A"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M22 21.0002H2L2.47826 17.435C2.69565 16.2611 3.73913 15.5654 4.91304 15.3046L12 14.0437L19.087 15.3046C20.2609 15.5654 21.3043 16.2611 21.4783 17.435L22 21.0002Z"
      stroke="#6A6A6A"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default User;
